import { observer } from 'mobx-react-lite'
import {
    Row,
    Col, Alert, Switch, InputNumber, Tooltip, Divider
} from 'antd'
import i from '../../../../translations/i'
import { __product } from '../__product'
import React, { useEffect } from 'react'
import { runInAction } from 'mobx'
import { WarehousesController } from '../../../settings/warehouses/warehouses.controller'
import { returnParseProjectElement } from '../../../../helpers/project.controller'
import price_types_controller from "../../../settings/price_types/controller";
import projectController from "../../../settings/project/project.controller";
import { storeLocal } from "../../../../helpers/stores";
import { canManageOwnedRecord } from "../../../../helpers/manager_ownership";

const Storage = new WarehousesController()

export const ProductWarehouses = observer(() => {

    const isFranchisee = storeLocal.get('role') === 6
    const allowedWarehouseIds: number[] = storeLocal.get('warehouses_access') || []
    const isNewProduct = !__product.item.id || __product.item.id === 0
    // На чужом товаре бэкенд (updateFranchiseeWarehousePrices) молча игнорирует view -
    // прячем несоответствие, блокируя переключатель там же, где он реально бесполезен.
    const viewToggleDisabled = isFranchisee && !isNewProduct && !canManageOwnedRecord(__product.item)

    useEffect(() => {
        Storage.get(1000)
        if (isFranchisee) __product.ensureFranchiseeStorages()
    }, [])

    const list = isFranchisee ? Storage.list.filter((el: any) => allowedWarehouseIds.includes(el.id)) : Storage.list

    return(
        <>
            {list && list.length > 0 &&
                <>
                    <Row gutter={[20, 20]}>
                        {list.map((el: any) => {
                            return (
                                <Col span={24} className="product_storage">
                                    <Row gutter={[20, 20]} justify="space-around">
                                        <Col span={15}>
                                            <p className="name">{el.name}</p>
                                        </Col>
                                        <Col span={9} className="right">
                                            <Tooltip
                                                title={i.t('def:view')}
                                            >
                                                <Switch
                                                    size="small"
                                                    disabled={viewToggleDisabled}
                                                    onChange={(e) => __product.setProductStorageID(el.id, e)}
                                                    checked={__product.item.storages.find((item: any) => item.warehouseid === el.id) && __product.item.storages.find((item: any) => item.warehouseid === el.id).view > 0}
                                                />
                                            </Tooltip>
                                        </Col>
                                        {__product.item.storages.find((item: any) => item.warehouseid === el.id) &&
                                            <>
                                                <Row gutter={[15, 15]}>
                                                    <Col span={8}>
                                                        <label className="formLabel">{i.t('product:price')}</label>
                                                        <InputNumber
                                                          style={{ width: '100%' }}
                                                          value={ __product.item.storages.find((item: any) => item.warehouseid === el.id).price }
                                                          onChange={ (e) => __product.setProductDataToStorage(el.id, "price", e > 0 ? e : 0) }
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <label className="formLabel">{i.t('product:oldPrice')}</label>
                                                        <InputNumber
                                                          style={{ width: '100%' }}
                                                          value={__product.item.storages.find((item: any) => item.warehouseid === el.id).priceold}
                                                          onChange={(e) => __product.setProductDataToStorage(el.id, "priceold", e > 0 ? e : 0)}
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <label className="formLabel">{i.t('product:count')}</label>
                                                        <InputNumber
                                                          style={{ width: '100%' }}
                                                          value={ __product.item.storages.find((item: any) => item.warehouseid === el.id).count }
                                                          onChange={ (e) => __product.setProductDataToStorage(el.id, "count", e > 0 ? e : 0) }
                                                        />
                                                    </Col>
                                                    {price_types_controller.items.length > 0 ? <>
                                                        <Col span={24}>
                                                            <Divider orientation="left">{i.t('def:Price types')}</Divider>
                                                            <Row gutter={[15, 15]}>
                                                                {price_types_controller.items.map((pt: any, index: number) => (
                                                                  <Col span={24}>
                                                                      <Row justify="space-between" align="bottom" gutter={[20, 20]}>
                                                                          <Col span={8}>
                                                                              <label className="formLabel">{i.t('product:priceType')}</label>
                                                                              <p>{pt.name ?? pt.private_name}</p>
                                                                          </Col>
                                                                          <Col span={8}>
                                                                              <label className="formLabel">{i.t('product:oldPrice')}</label>
                                                                              <InputNumber
                                                                                style={{ width: '100%' }}
                                                                                value={(__product.item.prices_wh.find((e: any) => e.price_type_id === pt.id && e.warehouse_id === el.id)?.old_price) || 0}
                                                                                onChange={(value: any) => __product.setWhPrice(pt.id, el.id, 'old_price', value)}
                                                                              />
                                                                          </Col>
                                                                          <Col span={8}>
                                                                              <label className="formLabel">{i.t('product:finalPrice')}</label>
                                                                              <InputNumber
                                                                                style={{ width: '100%' }}
                                                                                value={(__product.item.prices_wh.find((e: any) => e.price_type_id === pt.id && e.warehouse_id === el.id)?.price) || 0}
                                                                                onChange={(value: any) => __product.setWhPrice(pt.id, el.id, 'price', value)}
                                                                              />
                                                                          </Col>
                                                                      </Row>
                                                                      <Divider />
                                                                  </Col>
                                                                ))}
                                                            </Row>
                                                        </Col>
                                                    </> : <></>}

                                                </Row>
                                            </>
                                        }
                                    </Row>
                                </Col>
                            )
                        })}
                    </Row>
                </>
            }
        </>
    )
})